import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import parseISO from 'date-fns/parseISO';
import isBefore from 'date-fns/isBefore';
import startOfDay from 'date-fns/startOfDay';
import startOfToday from 'date-fns/startOfToday';

import { asFormSubmit } from 'components/Form';
import { selectActiveVenueId } from 'selectors/general';
import { selectInstructors, selectInstructorsIsLoading } from 'features/Instructors';
import {
  selectCreatedInstructorId,
  selectSchedulesClasses,
  selectSchedulesClassesIsLoading,
  selectScheduleInstance,
  selectScheduleInstanceIsLoading,
} from '../../Schedules.selectors';
import {
  updateScheduleInstance as updateScheduleInstanceAction,
  updateStartDate as updateStartDateAction,
} from '../../Schedules.saga';
import messages from '../ScheduleForm.messages';
import EditScheduleInstanceForm from './EditScheduleInstanceForm';

export const EDIT_SCHEDULE_INSTANCE_FORM_NAME = 'EDIT_SCHEDULE_INSTANCE_FORM_NAME';

export const validate = ({ capacity, networkSpots, startDate }) => {
  const errors = {};

  if (isBefore(startOfDay(parseISO(startDate)), startOfToday())) {
    errors.startDate = messages.validator.dateInThePast;
  }

  if (typeof capacity === 'number' && networkSpots > capacity) {
    errors.networkSpots = messages.validator.networkSpotsGreaterThanCapacity;
  }

  return errors;
};

export const mapStateToProps = state => {
  const venueId = selectActiveVenueId(state);
  const instance = selectScheduleInstance(state);
  const createdInstructorId = selectCreatedInstructorId(state);
  const {
    scheduleId,
    capacity,
    durationInMinutes,
    startDate,
    startTime,
    instructor = {},
    lastChange,
    recurrence = {},
    classId,
    classTitle,
  } = instance;
  const { originalRecurrenceDate: recurrenceDate } = recurrence;
  const { id: instructorId } = instructor || {};

  return {
    classTitle,
    classes: selectSchedulesClasses(state, venueId),
    initialValues: {
      scheduleId,
      recurrenceDate,
      capacity,
      durationInMinutes,
      classId,
      instructorId: createdInstructorId || instructorId,
      startDate,
      startTime,
    },
    instructors: selectInstructors(state, venueId),
    isLoading:
      selectScheduleInstanceIsLoading(state, venueId) ||
      selectInstructorsIsLoading(state, venueId) ||
      selectSchedulesClassesIsLoading(state, venueId),
    startDate,
    lastChange,
  };
};

const mapDispatchToProps = {
  updateScheduleInstance: updateScheduleInstanceAction,
  updateStartDate: updateStartDateAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { classTitle, startDate, ...restStateProps } = stateProps;
  const { updateScheduleInstance, updateStartDate } = dispatchProps;
  return {
    ...restStateProps,
    updateStartDate: updateStartDate.bind(null, parseISO(startDate)),
    onSave: asFormSubmit((values, asyncSubmitFns) => updateScheduleInstance({ classTitle, ...values }, asyncSubmitFns)),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  reduxForm({ form: EDIT_SCHEDULE_INSTANCE_FORM_NAME, validate, enableReinitialize: true })
)(EditScheduleInstanceForm);
